import { BaseModel, apolloMutation, MutationResult } from 'vue-apollo-model';
import gql from 'graphql-tag';
import { Mutation } from '@/generated-models';

export default class InteractiveModel extends BaseModel {
    @apolloMutation<InteractiveModel>({
        mutation: gql`
            mutation visionVideoLike($photoId: String, $photoAuthorId: String, $cancel: Int, $expTag: String) {
                visionVideoLike(photoId: $photoId, photoAuthorId: $photoAuthorId, cancel: $cancel, expTag: $expTag) {
                    result
                }
            }
        `,
        variables({ photoId, photoAuthorId, cancel, expTag }) {
            return {
                photoId,
                photoAuthorId,
                cancel,
                expTag,
            };
        },
    })
    private likeMutation!: MutationResult<
        { photoId: string; photoAuthorId: string; cancel: number; expTag: string },
        {
            visionVideoLike: Mutation['visionVideoLike'];
        }
    >;

    async likeVideo({ photoId, photoAuthorId, cancel, expTag }: { photoId: string, photoAuthorId: string, cancel: number, expTag: string }) {
        await this.likeMutation.mutate({
            photoId,
            photoAuthorId,
            cancel,
            expTag,
        });
    }

    get likeVideoResult() {
        return this.likeMutation.data.visionVideoLike?.result || 0;
    }

    @apolloMutation<InteractiveModel>({
        mutation: gql`
            mutation visionVideoFeedback($photoId: String, $type: Int, $expTag: String) {
                visionVideoFeedback(photoId: $photoId, type: $type, expTag: $expTag) {
                    result
                }
            }
        `,
        variables({ photoId, type, expTag }) {
            return {
                photoId,
                type,
                expTag,
            };
        },
    })
    private feedbackMutation!: MutationResult<
        { photoId: string; type: number; expTag: string },
        {
            visionVideoFeedback: Mutation['visionVideoFeedback'];
        }
    >;

    async feedbackVideo(photoId: string, type: number, expTag: string) {
        await this.feedbackMutation.mutate({
            photoId,
            type,
            expTag,
        });
    }

    get feedbackVideoResult() {
        return this.feedbackMutation.data.visionVideoFeedback?.result || 0;
    }
}
